import { render } from "./PriceManagement.vue?vue&type=template&id=9c694e04&scoped=true"
import script from "./PriceManagement.vue?vue&type=script&lang=js"
export * from "./PriceManagement.vue?vue&type=script&lang=js"

import "./PriceManagement.vue?vue&type=style&index=0&id=9c694e04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c694e04"]])

export default __exports__